'use strict';

export class District {
    constructor () {
        this.buildings = {};
        this.activeBuilding = null;
    }

    addBuilding(name,building){
        this.buildings[name] = building;
    }

    activateBuilding(name){
        if (this.activeBuilding && this.activeBuilding.isActive){
            this.activeBuilding.deactivate();
            this.activeBuilding = null;
        }

        this.buildings[name].activate();
        this.activeBuilding = this.buildings[name];
    }

    deactivateBuilding(){
        if (this.activeBuilding && this.activeBuilding.isActive){
            this.activeBuilding.deactivate();
            this.activeBuilding = null;
        }
    }

    getActiveBuilding(){
        return this.activeBuilding;
    }

    getDeactivatedBuildings(){
        return this.getBuildingsArray().filter(building => !building.isActive);
    }

    getBuilding(name){
        return this.buildings[name];
    }

    getBuildingsArray(){
        return Object.values(this.buildings);
    }

    getBuildingsInfoLength(){
         return  this.getBuildingsArray()
            .map(building => Object.keys(building.info).length > 0)
            .filter(info => info === true).length;
    }
}